module.exports = {"pageTitleText":"资源用量总览","resourceUsageLineChart":"资源用量折线图"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/zh-CN/subscription.json
// module id = 7PLr
// module chunks = 3